import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "phaneroo:token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown, false = logged out, object = logged in
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);

  // Hydrate user from /me
  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!token) { setUser(false); return; }
      try {
        const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (!cancelled) setUser(data);
      } catch (_e) {
        if (!cancelled) { setUser(false); localStorage.removeItem(TOKEN_KEY); setToken(null); }
      }
    }
    load();
    return () => { cancelled = true; };
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAdmin: user && user.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
